import Subledger from './Subledger'

// Accounts receivable subledger: what each customer owes.
export default function ARSubledger() {
  return <Subledger kind="ar" />
}
